<template>
  <v-chip v-if="trialStatus" :data-e2e-id="`trial-status-chip-${kebab(trialStatus.text)}`">
    <component :is="trialStatus.icon"></component>
    <b class="px-1">{{ trialStatus.text }}</b>
  </v-chip>
</template>

<script>
import _ from 'lodash'
import { TrialStatus } from '@/helpers/trial-helper'
import TrialStatusFeasibilityIcon from '@/assets/icons/TrialStatusFeasibilityIcon'
import TrialStatusOpenIcon from '@/assets/icons/TrialStatusOpenIcon'
import TrialStatusSuspendedIcon from '@/assets/icons/TrialStatusSuspendedIcon'
import TrialStatusClosedIcon from '@/assets/icons/TrialStatusClosedIcon'
import TrialStatusMatchingIcon from '@/assets/icons/TrialStatusMatchingIcon'

export default {
  components: {
    TrialStatusFeasibilityIcon,
    TrialStatusOpenIcon,
    TrialStatusSuspendedIcon,
    TrialStatusClosedIcon,
    TrialStatusMatchingIcon
  },
  props: {
    status: { type: String, default: null }
  },
  computed: {
    trialStatus() {
      return _.find(TrialStatus, it => it.value === this.status)
    }
  },
  methods: {
    kebab(selector) {
      return _.kebabCase(selector)
    }
  }
}
</script>
